export const TKeyCommon = {
  COMMON_BETA: "COMMON_BETA",
  NOT_FOUND_TITLE: "NOT_FOUND_TITLE",
  NOT_FOUND_DESCRIPTION: "NOT_FOUND_DESCRIPTION",
  NOT_FOUND_HOME: "NOT_FOUND_HOME",
  SEND: "SEND",
  VALIDATE: "VALIDATE",
  EDIT: "EDIT",
  DELETE: "DELETE",
  OTHER: "OTHER",
  CANCEL: "CANCEL",
  SAVE: "SAVE",
  COPY: "COPY",
  COPIED: "COPIED",
  OR: "OR",
  INSTALL_EXTENSION: "INSTALL_EXTENSION",
  INSTALL_EXTENSION_TOOLTIP: "INSTALL_EXTENSION_TOOLTIP",
  NEW_DOTS: "NEW_DOTS",
  ADD_ITEM: "ADD_ITEM",
  TIME_MOMENT: "TIME_MOMENT",
  NEW_ACTIVITY: "NEW_ACTIVITY",
  INVITATIONS_PENDING_TITLE: "INVITATIONS_PENDING_TITLE",
  INVITATION_PENDING_BADGE: "INVITATION_PENDING_BADGE",
  INVITATION_CANCEL_TITLE: "INVITATION_CANCEL_TITLE",
  INVITATION_CANCEL_TEXT: "INVITATION_CANCEL_TEXT",
  INVITATION_CANCEL_CONFIRM: "INVITATION_CANCEL_CONFIRM",
} as const;
